var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModuleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.914 0.554999H4.479L11.981 7.654L4.479 14.784H0.914L8.416 7.654L0.914 0.554999Z",
    fill: "#F6821F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleIcon);
export default __webpack_public_path__ + "static/media/module_icon.0eeb2a35de14d0a70f377c646832c860.svg";
export { ForwardRef as ReactComponent };